export enum CreateTopologyRoutes {
  DemoImport = '/demo-import',
  DemoType = '/demo-type',
  Details = '/details',
}
